import React from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

import { useRecordContext, useGetOne } from 'react-admin';

import Params from './Params';
import { requestTypes } from '../../constants/requestTypes';
import { EntityTypes } from '../../constants/entityTypes';
import TransactionSummaryTable from './TransactionSummaryTable';
import TransactionTableSetup from '../../constants/transactionTableSetup';

const Summary = ({
  params,
  filter,
  defaultConfiguration,
}: {
  params: Params;
  filter: {
    from: string;
    to: string;
    currency: string;
    entityId: string;
    entityType: EntityTypes;
    requestType: typeof requestTypes.TRANSACTION;
  };
  defaultConfiguration?: TransactionTableSetup;
}) => {
  const entityRecord = useRecordContext<{ id: string }>();

  if (!entityRecord) return null;

  return (
    <Grid container spacing={6}>
      <Grid size={12}>
        <TransactionSummaryTable
          params={params}
          filter={filter}
          defaultConfiguration={defaultConfiguration}
          showExpectedBehaviourInput
          preferenceKey="transaction-summary-table"
        />
      </Grid>
    </Grid>
  );
};

const ConfiguredSummary = ({
  params,
  filter,
}: {
  params: Params;
  filter: {
    from: string;
    to: string;
    currency: string;
    entityId: string;
    entityType: EntityTypes;
    requestType: typeof requestTypes.TRANSACTION;
  };
}) => {
  const { data: defaultConfiguration, isLoading } = useGetOne<TransactionTableSetup>('transaction-table-setup', { id: filter.entityType });

  return isLoading ? (
    <Box display="flex" justifyContent="center">
      <CircularProgress size={20} color="inherit" />
    </Box>
  ) : (
    <Summary
      params={params}
      filter={filter}
      defaultConfiguration={defaultConfiguration}
    />
  );
};

export default ConfiguredSummary;
